import React, { useState, useEffect, useContext } from 'react';

import animacaoNivelData from '../../assets/animacaoNivel.json';
import { AuthContext } from "../../contexts/auth";
import './game.css';
import Header from "../../components/Header";
import Title from "../../components/Title";
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import "react-vertical-timeline-component/style.min.css";
import { FiSmile, FiCompass, FiFlag, FiMap, FiGlobe, FiStar, FiSun, FiFeather, FiTriangle, FiAward, FiCheckCircle, FiWind, FiTarget, FiAnchor, FiTrendingUp } from "react-icons/fi";

function TelaGamificacao() {
  const { user } = useContext(AuthContext);
  const [game, setGame] = useState({ selos: [] });
  const [xpAtual, setXpAtual] = useState(0);
  const [nivel, setNivel] = useState(1);
  const [mostrarAnimacao, setMostrarAnimacao] = useState(false);
  const { getGame } = useContext(AuthContext);

  useEffect(() => {
    const fetchGameData = async () => {
      if (user?.user_id) {
        try {
          const gameData = await getGame(user.user_id);
          if (gameData) {
            setGame(gameData);
            setXpAtual(gameData?.xp ?? 0);
            setNivel(gameData?.nivel ?? 1);
          }
        } catch (error) {
          console.error("Erro ao carregar os dados de gamificação:", error);
        }
      }
    };

    fetchGameData();
  }, [user, getGame]);

 
  useEffect(() => {
    if (mostrarAnimacao) {
      const timeoutId = setTimeout(() => setMostrarAnimacao(false), 2000);
      return () => clearTimeout(timeoutId); 
    }
  }, [mostrarAnimacao, nivel]); 
  
  const xpParaProximoNivel = (nivel) => {
    return 150 * nivel;
  };

  const animacaoOptions = {
    loop: false,
    autoplay: true,
    animationData: animacaoNivelData,
  };

  if (!user) {
    return <p>Carregando dados de gamificação...</p>;
  }

  return (
    <div >
      <Header />
      <div className="contentt">
        <Title name="Conquistas">
          <FiAward size={25} />
        </Title>
      </div>
      <div className="tela-gamificacao">

        <div className="nivel-section">
          <h2>Nível: {nivel}</h2>
          <progress value={xpAtual} max={xpParaProximoNivel(nivel)} />
          <p>{xpAtual}/{xpParaProximoNivel(nivel)} XP</p>
        </div>

        {mostrarAnimacao && (
          <div className="animacao-nivel">
            <h3>Parabéns! Você subiu para o nível {nivel}!</h3>
          </div>
        )}

      </div>
      <br />
      <div className='level'>
        <VerticalTimeline key={nivel} lineColor='#69B578'>
          {nivel >= 1 && (
            <VerticalTimelineElement className='vertical-elem' iconStyle={{ backgroundColor: "#69B578", color: "#fff" }}
              icon={<FiSmile />}>
              <h3 className='nivel1'>Uhulll! Você agora é um aventureiro Iniciante!</h3>
            </VerticalTimelineElement>
          )}

          {nivel >= 2 && (
            <VerticalTimelineElement className='vertical-elem' iconStyle={{ backgroundColor: "#69B578", color: "#fff" }}
              icon={<FiCompass />}>
              <h3 className='nivel1'>Parabéns! Você desbloqueou o caminho do Explorador Curioso!</h3>
            </VerticalTimelineElement>
          )}

          {nivel >= 3 && (
            <VerticalTimelineElement className='vertical-elem' iconStyle={{ backgroundColor: "#69B578", color: "#fff" }}
              icon={<FiFlag />}>
              <h3 className='nivel1'>Você está dominando as trilhas! Bem-vindo ao status de Desbravador!</h3>
            </VerticalTimelineElement>
          )}

          {nivel >= 4 && (
            <VerticalTimelineElement className='vertical-elem' iconStyle={{ backgroundColor: "#69B578", color: "#fff" }}
              icon={<FiMap />}>
              <h3 className='nivel1'>Seu mapa está cheio de aventuras! Você agora é um Viajante Experiente!</h3>
            </VerticalTimelineElement>
          )}

          {nivel >= 5 && (
            <VerticalTimelineElement className='vertical-elem' iconStyle={{ backgroundColor: "#69B578", color: "#fff" }}
              icon={<FiGlobe />}>
              <h3 className='nivel1'>O mundo é seu playground! Parabéns por alcançar o nível de Explorador Global!</h3>
            </VerticalTimelineElement>
          )}

          {nivel >= 6 && (
            <VerticalTimelineElement className='vertical-elem' iconStyle={{ backgroundColor: "#69B578", color: "#fff" }}
              icon={<FiStar />}>
              <h3 className='nivel1'>Você está brilhando nas aventuras! Bem-vindo ao Clube dos Estrelas de Viagem!</h3>
            </VerticalTimelineElement>
          )}

          {nivel >= 7 && (
            <VerticalTimelineElement className='vertical-elem' iconStyle={{ backgroundColor: "#69B578", color: "#fff" }}
              icon={<FiSun />}>
              <h3 className='nivel1'>O sol brilha mais forte nas suas trilhas! Agora você é um Explorador Iluminado!</h3>
            </VerticalTimelineElement>
          )}

          {nivel >= 8 && (
            <VerticalTimelineElement className='vertical-elem' iconStyle={{ backgroundColor: "#69B578", color: "#fff" }}
              icon={<FiFeather />}>
              <h3 className='nivel1'>Leve como uma pluma, suas jornadas ganham força! Você agora é um Nômade Ágil!</h3>
            </VerticalTimelineElement>
          )}

          {nivel >= 9 && (
            <VerticalTimelineElement className='vertical-elem' iconStyle={{ backgroundColor: "#69B578", color: "#fff" }}
              icon={<FiTriangle />}>
              <h3 className='nivel1'>Você está no topo do mundo! Seu título agora é Mestre das Montanhas!</h3>
            </VerticalTimelineElement>
          )}

          {nivel >= 10 && (
            <VerticalTimelineElement className='vertical-elem' iconStyle={{ backgroundColor: "#69B578", color: "#fff" }}
              icon={<FiAward />}>
              <h3 className='nivel1'>Parabéns, suas conquistas são dignas de um Troféu de Aventuras! Continue assim!</h3>
            </VerticalTimelineElement>
          )}

          {nivel >= 11 && (
            <VerticalTimelineElement className='vertical-elem' iconStyle={{ backgroundColor: "#69B578", color: "#fff" }}
              icon={<FiCheckCircle />}>
              <h3 className='nivel1'>Você é um verdadeiro Campeão de Jornada! Seu espírito é inabalável!</h3>
            </VerticalTimelineElement>
          )}

          {nivel >= 12 && (
            <VerticalTimelineElement className='vertical-elem' iconStyle={{ backgroundColor: "#69B578", color: "#fff" }}
              icon={<FiWind />}>
              <h3 className='nivel1'>Viajando com o vento! Você se tornou um Explorador do Horizonte!</h3>
            </VerticalTimelineElement>
          )}

          {nivel >= 13 && (
            <VerticalTimelineElement className='vertical-elem' iconStyle={{ backgroundColor: "#69B578", color: "#fff" }}
              icon={<FiTarget />}>
              <h3 className='nivel1'>Cada destino é um alvo conquistado! Bem-vindo ao Hall dos Aventureiros Precisos!</h3>
            </VerticalTimelineElement>
          )}

          {nivel >= 14 && (
            <VerticalTimelineElement className='vertical-elem' iconStyle={{ backgroundColor: "#69B578", color: "#fff" }}
              icon={<FiAnchor />}>
              <h3 className='nivel1'>Sua âncora está firmada em mares distantes! Agora você é um Navegador Destemido!</h3>
            </VerticalTimelineElement>
          )}

          {nivel >= 15 && (
            <VerticalTimelineElement className='vertical-elem' iconStyle={{ backgroundColor: "#69B578", color: "#fff" }}
              icon={<FiTrendingUp />}>
              <h3 className='nivel1'>Você chegou ao ápice! Parabéns, Aventureiro Supremo!</h3>
            </VerticalTimelineElement>
          )}
        </VerticalTimeline>
      </div>

      <br />
    </div>

  );
}

export default TelaGamificacao;
